import { SEO } from "@/components/SEO";
import { headTageTitle } from "@/utils/head-tag-title";
import { getConfigSSR } from "api/config";
import { useMemo } from "react";
import { useAppSelector } from "store/hooks";
import { ConfigPage, NextPageWithLayoutAndPageType } from "types/index";

const TicketRatePage: NextPageWithLayoutAndPageType = (props: any) => {
  const storeConfig = useAppSelector((state) => state.config);
  const config = props.config || storeConfig;

  const siteTitleFromHeadTag = useMemo(() => headTageTitle(config), [config]);

  const siteName = siteTitleFromHeadTag
    ? siteTitleFromHeadTag
    : config.company_info?.name;
  const seoconfig = config.pages?.find(
    (page: ConfigPage) => page?.page_type === "ticket_rate",
  )?.config;
  const description =
    seoconfig?.description ||
    `View ticket prices and rates at ${siteName}. Find pricing for different movie formats, showtimes, and seat categories.`;
  const title = seoconfig?.title || "Ticket Prices & Rates";
  const keywords = seoconfig?.keywords || [
    "ticket prices",
    "rates",
    "pricing",
    "movie tickets",
    "cost",
    siteName,
  ];

  return (
    <SEO
      title={title}
      description={description}
      keywords={keywords}
      siteName={siteName}
    />
  );
};

TicketRatePage.page_type = "ticket_rate";
export const getServerSideProps = getConfigSSR;

export default TicketRatePage;
